import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiCheckbox from '@material-ui/core/Checkbox';

function Checkbox(props) {
    const { disabled, field, input, meta: { touched, error } } = props;

    return (
        <FormControlLabel
            id={input.name}
            control={
                <MuiCheckbox
                    // checked={state.checkedB}
                    // onChange={handleChange}
                    name={input.name}
                    color="primary"
                    required={field.required === true}
                    disabled={disabled}
                    // error={touched && error}
                    {...input}
                />
            }
            label={field.required ? <>{field.label} *</> : field.label}
        />
    );
}

export default Checkbox;
